import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";
import { fetchMessageReport, resolveReport, updateMessage } from '../../messages/messageActions';

import MessageReportHandler from './MessageReportHandler';

const mapStateToProps = state => ({
    report: state.message.report,
    locale: state.session.language
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchMessageReport,
    resolveReport,
    updateMessage
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(MessageReportHandler);